module.exports = __webpack_public_path__ + "static/media/credit-card.4b3b493c.svg";